import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: NavigationState = {
    mobileMenus: {
        main: {
            open: false,
        },
        profile: {
            open: false,
        },
        search: {
            open: false,
        },
        quotation: {
            open: false,
        },
    },
};

export const navigationSlice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        setMobileMenuOpen: (
            state,
            action: PayloadAction<setMobileMenuOpenPayload>
        ) => {
            state.mobileMenus[action.payload.menu].open = action.payload.open;
        },
    },
});

export interface NavigationState {
    mobileMenus: MobileMenus;
}

interface MenuState {
    open: boolean;
}

interface MobileMenus {
    main: MenuState;
    profile: MenuState;
    search: MenuState;
    quotation: MenuState;
}

interface setMobileMenuOpenPayload {
    menu: keyof MobileMenus;
    open: boolean;
}

export const navigationAction = navigationSlice.actions;

export default navigationSlice.reducer;
